import script from "./ForbiddenJoin.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForbiddenJoin.vue?vue&type=script&setup=true&lang=ts"

import "./ForbiddenJoin.vue?vue&type=style&index=0&id=ce15cdee&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce15cdee"]])

export default __exports__